import { createSlice } from '@reduxjs/toolkit';
import { deletebranchById, createBranch , UpdateBranch , fetchAllBranch,fetchBranchById } from './branch.Action';
import { branchState , branch } from './branch.Type';

const initialState : branchState ={
    branch : [],
    selectedbranch : undefined,
    loadingStates : {
        create: false,
        update: false,
        delete: false,
        fetchById: false,
        fetchAll: false,
    },
    errors: {
        create: undefined,
        update: undefined,
        delete: undefined,
        fetchById: undefined,
        fetchAll: undefined,
    },
}


const  BranchSlice = createSlice ({
    name : 'branch' ,
    initialState,
    reducers:{},
    extraReducers : (builder) =>{
        builder
           .addCase(createBranch.pending, (state) => {
                                   state.loadingStates.create = true;
                                   state.errors.create = undefined;
                               })
                               .addCase(createBranch.fulfilled, (state, action) => {
                                   state.loadingStates.create = false;
                                   state.branch.push(action.payload);
                               })
                               .addCase(createBranch.rejected, (state, action) => {
                                   state.loadingStates.create = false;
                                   state.errors.create = action.payload as string;
                               })
                   
                               // Update 
                               .addCase(UpdateBranch.pending, (state) => {
                                   state.loadingStates.update = true;
                                   state.errors.update = undefined;
                               })
                               .addCase(UpdateBranch.fulfilled, (state, action) => {
                                   state.loadingStates.update = false;
                                   const index = state.branch.findIndex((d : any) => d.Id === action.payload.Id);
                                   if (index !== -1) {
                                       state.branch[index] = action.payload;
                                   }
                               })
                               .addCase(UpdateBranch.rejected, (state, action) => {
                                   state.loadingStates.update = false;
                                   state.errors.update = action.payload as string;
                               })
                   
                            //delete 
                               .addCase(deletebranchById.pending, (state) => {
                                   state.loadingStates.delete = true;
                                   state.errors.delete = undefined;
                               })
                               .addCase(deletebranchById.fulfilled, (state, action) => {
                                   state.loadingStates.delete = false;
                                   state.branch = state.branch.filter((d : any) => d.Id !== action.payload);
                               })
                               .addCase(deletebranchById.rejected, (state, action) => {
                                   state.loadingStates.delete = false;
                                   state.errors.delete = action.payload as string;
                               })
                   
                               // Fetch  by ID
                               .addCase(fetchBranchById.pending, (state) => {
                                   state.loadingStates.fetchById = true;
                                   state.errors.fetchById = undefined;
                               })
                               .addCase(fetchBranchById.fulfilled, (state, action) => {
                                   state.loadingStates.fetchById = false;
                                   state.selectedbranch = action.payload;
                               })
                               .addCase(fetchBranchById.rejected, (state, action) => {
                                   state.loadingStates.fetchById = false;
                                   state.errors.fetchById = action.payload as string;
                               })
                   
                               // Fetch All 
                               .addCase(fetchAllBranch.pending, (state) => {
                                   state.loadingStates.fetchAll = true;
                                   state.errors.fetchAll = undefined;
                               })
                               .addCase(fetchAllBranch.fulfilled, (state, action) => {
                                   state.loadingStates.fetchAll = false;
                                   state.branch = action.payload.data;
                               })
                               .addCase(fetchAllBranch.rejected, (state, action) => {
                                   state.loadingStates.fetchAll = false;
                                   state.errors.fetchAll = action.payload as string;
                               }); 
    }
})

export default BranchSlice.reducer;